/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Play_ReplayInputs */

const en_endpoint_play_replay = /** @type {(inputs: Endpoint_Play_ReplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replay`)
};

const zh_hans1_endpoint_play_replay = /** @type {(inputs: Endpoint_Play_ReplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重播`)
};

const pt_br2_endpoint_play_replay = /** @type {(inputs: Endpoint_Play_ReplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetir`)
};

const es_endpoint_play_replay = /** @type {(inputs: Endpoint_Play_ReplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetir`)
};

const fr_endpoint_play_replay = /** @type {(inputs: Endpoint_Play_ReplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejouer`)
};

const de_endpoint_play_replay = /** @type {(inputs: Endpoint_Play_ReplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholen`)
};

const ru_endpoint_play_replay = /** @type {(inputs: Endpoint_Play_ReplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторить`)
};

const it_endpoint_play_replay = /** @type {(inputs: Endpoint_Play_ReplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riproduci di nuovo`)
};

/**
* | output |
* | --- |
* | "Replay" |
*
* @param {Endpoint_Play_ReplayInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_play_replay = /** @type {((inputs?: Endpoint_Play_ReplayInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Play_ReplayInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_play_replay(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_play_replay(inputs)
	if (locale === "es") return es_endpoint_play_replay(inputs)
	if (locale === "fr") return fr_endpoint_play_replay(inputs)
	if (locale === "de") return de_endpoint_play_replay(inputs)
	if (locale === "ru") return ru_endpoint_play_replay(inputs)
	if (locale === "it") return it_endpoint_play_replay(inputs)
	return en_endpoint_play_replay(inputs)
});